/** Angielskie nazwy dziennika audytu (`aud.labels.*`) — typowane względem `audLabelsPl`, brakujący klucz to błąd kompilacji. */
import type { Shape, audLabelsPl } from './audit-labels';

export const audLabelsEn: Shape<typeof audLabelsPl> = {
  entities: {
    Ai: 'AI assistant',
    Alerts: 'Alerts',
    Analytics: 'Analytics',
    AnalyticsCustomers: 'Analytics — customers',
    AnalyticsFinance: 'Analytics — finance',
    AnalyticsOps: 'Analytics — operations',
    AnalyticsProducts: 'Analytics — products',
    Attachments: 'Attachments',
    Audit: 'Audit log',
    Auth: 'Sign-in and account',
    Cashflow: 'Cash flow',
    Chat: 'Chat',
    ChatStream: 'Chat',
    Checklists: 'Checklists',
    Claims: 'Claims',
    ClaimsDocuments: 'Claims — documents',
    ClaimsQueue: 'Claims — queue',
    Collections: 'Collections',
    Commissions: 'Commissions',
    CompetitorSuppliers: 'Competitor suppliers',
    CostDepartments: 'Cost departments',
    Costs: 'Costs',
    CustomerContacts: 'Customer contacts',
    CustomerDocuments: 'Customer documents',
    CustomerLifecycle: 'Customer lifecycle',
    CustomerProfile: 'Customer profile',
    Customers: 'Customers',
    DailyReport: 'Daily report',
    DailyReportSheet: 'Daily report sheet',
    Demo: 'Demo mode',
    ErpOutboxAdmin: 'ERP outbox — administration',
    ErpOutboxIntegration: 'ERP outbox',
    ErpSync: 'ERP sync',
    Exports: 'Exports',
    Field: 'Field',
    FieldForeign: 'Field — other reps’ customers',
    FieldVisits: 'Field — visits',
    FleetAnalytics: 'Fleet — analytics',
    FleetAttachments: 'Fleet — attachments',
    FleetInsights: 'Fleet — insights',
    FleetInsightsUi: 'Fleet — insights',
    FleetRouteSync: 'Fleet — route sync',
    FuelExpenses: 'Fuel and expenses',
    Gdpr: 'Personal data (GDPR)',
    Geocoding: 'Address geocoding',
    Incidents: 'Fleet incidents',
    InsuranceAnalytics: 'Insurance — analytics',
    InsuranceContracts: 'Insurance — contracts',
    InsuranceCoverage: 'Insurance — coverage',
    InsuranceImports: 'Insurance — import',
    InsurancePolicies: 'Policies',
    InvoiceCompare: 'Invoice comparison',
    Leads: 'Leads',
    Leases: 'Leasing',
    Leave: 'Leave',
    Logbooks: 'Logbooks',
    Logistics: 'Logistics',
    LogisticsOptimization: 'Logistics — optimization',
    LogisticsReports: 'Logistics — reports',
    MbrClose: 'Month close',
    MbrCloseForms: 'Month close — forms',
    MbrCloseImport: 'Month close — import',
    MbrCommon: 'Board report',
    MbrComplaints: 'Board report — complaints',
    MbrCustomers: 'Board report — customers',
    MbrDisposals: 'Board report — disposals',
    MbrFinance: 'Board report — finance',
    MbrInsights: 'Board report — insights',
    MbrLogistics: 'Board report — logistics',
    MbrOperations: 'Board report — operations',
    MbrReport: 'Board report',
    MbrSales: 'Board report — sales',
    MyDay: 'My day',
    MySummary: 'My summary',
    Notifications: 'Notifications',
    NotificationsAnnounce: 'Announcements',
    Organization: 'Organization',
    OwnerDashboard: 'Owner dashboard',
    Planner: 'Planner',
    PlannerOrgSettings: 'Planner — settings',
    PlannerPeople: 'Planner — people',
    PlannerSetup: 'Planner — setup',
    PlannerVacation: 'Planner — vacation',
    Prices: 'Price lists',
    Purchasing: 'Purchasing',
    Push: 'Push notifications',
    Quality: 'Quality',
    QualityEvents: 'Quality — events',
    RepSales: 'Rep sales',
    RouteOptions: 'Route options',
    Routing: 'Routes',
    SalesOrders: 'Orders',
    Search: 'Search',
    Surveys: 'Surveys',
    Tasks: 'Tasks',
    TenderAttachments: 'Tenders — attachments',
    Tenders: 'Tenders',
    Users: 'Users',
    Vehicles: 'Vehicles',
    Warehouse: 'Warehouse',
    WarehouseAdmin: 'Warehouse — settings',
    Workflow: 'Approvals',
    Worktime: 'Working time',
    WorktimeAdmin: 'Working time — settings',
    Attachment: 'Attachment',
    AuditLog: 'Audit log',
    CUSTOMER_DOCUMENT_SEND: 'Document sent to customer',
    CashBankBalance: 'Cash and bank balance',
    Contact: 'Contact',
    Customer: 'Customer',
    CustomerDocumentSend: 'Document sent to customer',
    CustomerMenuLink: 'Customer menu link',
    CustomerRetro: 'Customer retro',
    Delivery: 'Delivery',
    DriverGroup: 'Driver group',
    EXPENSE: 'Expense',
    ErpEmployee: 'ERP employee',
    Export: 'Export',
    FLEET_CHECKLIST_ANSWER: 'Checklist answer',
    FLEET_FUEL: 'Refuelling',
    FUEL: 'Refuelling',
    FleetChecklistRun: 'Completed checklist',
    FleetChecklistTemplate: 'Checklist template',
    FleetExpense: 'Fleet expense',
    FleetExternalIdMap: 'External system link',
    FleetFuelEntry: 'Refuelling',
    FleetIncident: 'Fleet incident',
    FleetIncidentTemplate: 'Fleet incident template',
    FleetRouteSyncRun: 'Route sync',
    FleetServiceRecord: 'Vehicle service',
    FleetSettings: 'Fleet settings',
    ForeignCustomerBrowse: 'Other reps’ customers',
    ForeignCustomerLookup: 'Other rep’s customer nearby',
    ForeignCustomerView: 'Other rep’s customer card',
    INCIDENT: 'Fleet incident',
    INSURANCE_CLAIM: 'Claim',
    LEASE: 'Leasing',
    LOGBOOK: 'Logbook',
    LeaseContract: 'Lease contract',
    Logbook: 'Logbook',
    MbrImport: 'Board report import',
    MbrMonthClose: 'Month close',
    OdometerReading: 'Odometer reading',
    OrganizationPlannerSettings: 'Planner settings',
    OrganizationSettings: 'Organization settings',
    PlannerShift: 'Schedule shift',
    PlannerTaskTemplate: 'Task template',
    RepSalesBatch: 'Rep sales batch',
    RepSalesReminder: 'Sales reminder',
    ScheduleRequest: 'Schedule change request',
    SettlementPeriod: 'Settlement period',
    ShiftAttributeDef: 'Shift attribute',
    SurveyTemplate: 'Survey template',
    TimeEntry: 'Time entry',
    User: 'User',
    VEHICLE: 'Vehicle',
    VacationEntitlement: 'Vacation entitlement',
    Vehicle: 'Vehicle',
    VehicleAssignment: 'Vehicle assignment',
    Visit: 'Visit',
    WorkTime: 'Working time',
    WorkTimeProfile: 'Working time profile',
    WorkingTimeRuleset: 'Working time rules',
  },
  keys: {
    zdarzenie: 'Event',
    operacja: 'Operation',
    numer: 'Document number',
    odbiorca: 'Recipient',
    kanal: 'Channel',
    decyzja: 'Decision',
    odmowa: 'Access denied',
    reason: 'Reason',
    email: 'Email',
    employeeId: 'Employee number',
    role: 'Role',
    target: 'Target',
    format: 'Format',
    count: 'Records',
    rows: 'Rows',
    scope: 'Scope',
    method: 'Method',
    path: 'Path',
    source: 'Source',
    kind: 'Event type',
    page: 'List page',
    search: 'Search phrase',
    customerIds: 'Customers on the page',
    customerId: 'Customer',
    foreignTotal: 'Total matching',
    ownerId: 'Account owner',
    userId: 'User',
    fromUserId: 'From user',
    toUserId: 'To user',
    nextTaskAssigneeId: 'Next task assignee',
    visitId: 'Visit',
    vehicleId: 'Vehicle',
    subjectId: 'Person',
    truncated: 'List truncated',
    visibility: 'Visibility',
    radiusM: 'Radius (m)',
    distanceM: 'Distance (m)',
    lat: 'Latitude',
    lng: 'Longitude',
    handler: 'System operation',
    filters: 'Filters',
    status: 'Status',
    period: 'Period',
    date: 'Date',
    from: 'From',
    to: 'To',
    note: 'Note',
    query: 'Query',
    trigger: 'Trigger',
    dryRun: 'Dry run',
    sent: 'Sent',
    failed: 'Failed',
    recipients: 'Recipients',
    attachments: 'Attachments',
    bytes: 'Size (bytes)',
    op: 'Operation',
    event: 'Event',
    action: 'Action',
  },
  values: {
    kind: {
      FOREIGN_CUSTOMER_BROWSE: 'Browsing the list of other reps’ customers',
      FOREIGN_CUSTOMER_GEO: 'Other reps’ customers on the map',
      FOREIGN_CUSTOMER_VIEW: 'Opened another rep’s customer card',
      FOREIGN_CUSTOMER_LOOKUP: 'Other rep’s customer nearby',
    },
    scope: { foreign: 'Other reps’ customers', mine: 'My customers', all: 'All customers' },
    visibility: { LIMITED: 'Limited', NONE: 'None' },
  },
  view: 'Data access',
  more: '+{count} more',
  openCustomer: 'Open the customer card',
  fullId: 'Identifier: {id}',
};
